import React from 'react'
import { Form, Input, Button, Checkbox } from 'antd';
import { auth, db } from '../../firebase';
import { useHistory, withRouter } from 'react-router-dom';
import { useDispatch } from 'react-redux'
import { userObserver } from './userObserver';
import { voteObserver } from '../TabulationPage/voteObserver'
import swal from 'sweetalert'
import { actions } from '../../redux';

const layout = {
    labelCol: {
        span: 8,
    },
    wrapperCol: {
        span: 8,
    },
};
const tailLayout = {
    wrapperCol: {
        offset: 8,
        span: 8,
    },
};

function Auth(props) {
    const dispatch = useDispatch()
    const history = useHistory();
    const onFinish = (values) => {
        auth.signInWithEmailAndPassword(values.email, values.password).then(res => {
            db.collection('users').doc(values.email).get().then(doc => {
                const data = { ...doc.data(), isLoggedIn: true }
                switch(data.type) {
                    case 'Approver':
                        userObserver([dispatch])
                        dispatch(actions.signedIn(data))
                        history.push('/stsi')
                        break;
                    case 'Stockholder':
                        dispatch(actions.signedIn(data))
                        history.push('/Voting2022ASM')
                        break;
                    case 'Corporate Secretary':
                        voteObserver([dispatch])
                        userObserver([dispatch])
                        dispatch(actions.signedIn(data))
                        history.push('/tabulation')
                        break;
                    default:
                        history.push('/')
                        break;
                }
            })
        })
        .catch(err => {
            swal("Oops!", err, "error")
        })
    };
    
    const onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };

    return (
        <Form
            {...layout}
            name="basic"
            initialValues={{
            remember: true,
            }}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
        >
            <Form.Item
                label="Email"
                name="email"
                rules={[
                    {
                    required: true,
                    message: 'Please input your email!',
                    },
                ]}
            >
                <Input />
            </Form.Item>

            <Form.Item
                label="Password"
                name="password"
                rules={[
                    {
                    required: true,
                    message: 'Please input your password!',
                    },
                ]}
            >
                <Input.Password />
            </Form.Item>

            <Form.Item {...tailLayout}>
                <Button type="primary" htmlType="submit">
                    Submit
                </Button>
            </Form.Item>
        </Form>
    )
}

export default withRouter(Auth)
